import {
  ACCESS_LEVELS,
} from '@/lib/consts.js'
import { ROUTE_META_PARAMS } from '@/router/consts.js'

export default {
  path: 'turn-tracker',
  name: 'turn-tracker',
  meta: {
    [ROUTE_META_PARAMS.ACCESS_LEVEL]: ACCESS_LEVELS.RECEPTION,
    defaultSubroute: {
      name: 'turn-tracker.dashboard',
    },
  },
  component: () => import('@/views/business/turn-tracker/index.vue'),
  children: [
    {
      path: 'dashboard',
      name: 'turn-tracker.dashboard',
      component: () => import('@/views/business/turn-tracker/dashboard.vue'),
    },
    {
      path: 'manage-staff',
      name: 'turn-tracker.manage-staff',
      component: () => import('@/views/business/turn-tracker/manage-staff.vue'),
    },
    {
      path: 'settings',
      name: 'turn-tracker.settings',
      component: () => import('@/views/business/turn-tracker/turn-tracker-settings.vue'),
      meta: {
        [ROUTE_META_PARAMS.ACCESS_LEVEL]: ACCESS_LEVELS.MANAGER,
      },
    },
  ],
}
